import React, { useMemo, useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import AdminMaster from '../../../Layout/admin/Master';
import { Link, useNavigate } from 'react-router-dom';
import { Toast, ToastContainer, OverlayTrigger, Modal, Form, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import datatableCustomStyles from './../../../Layout/Elements/DatatableCustomStyles';
import axiosInstance from './../../../axiosInstance';
import { useFormik } from 'formik';
import { BiComment, BiExport, BiFile, BiHistory, BiPaperPlane, BiReset, BiSearch, BiTimer, BiUserPlus } from 'react-icons/bi';
import DateTimePicker from 'react-datetime-picker';
import { ediValidate835List, fetchAllLockboxFiles, generateOperationLog, generateOutputZip, getChangeJobTat, getLockboxLogDetailsReport, getUserlist, getUserManualAssign, lockboxComment, resendEobOutputFIleSchema, toggleLockbox } from '../../../Redux/qms/action';
import { GET_ALL_SFTP_FILES_URL } from '../../../api';
import { IoIosSwitch } from 'react-icons/io';
// import { LOCKBOX_FILES_QMS, SINGLE_LOCKBOX_LOCKBOX_FILES, SINGLE_SPLIT } from '../../../routeNames';
import moment from 'moment';
import { getAllClients } from '../../../Redux/client/action';
import { getAllSftpFilesFilter, rejectSftpFile } from '../../../Redux/fileSplit/action';
import DateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';
import queueDatatableCustomStyles from '../../../Layout/Elements/QueueDatatableCustomStyles';
import SweetAlert from 'react-bootstrap-sweetalert';
import Select, { components, DropdownIndicatorProps } from 'react-select';
import { getAllClientDropdown } from '../../../Redux/client/action';
// import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import * as Yup from 'yup';
import 'rsuite/dist/rsuite.min.css';
import { Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import DateRangePicker from 'rsuite/DateRangePicker';

import { GET_ACKNOWLEDGMENT_LIST, LOCKBOX_FILES_QMS, SINGLE_LOCKBOX_LOCKBOX_FILES } from '../../../routeNames';
import { HiChevronDown } from 'react-icons/hi';
import { TbGridDots, TbHandGrab } from 'react-icons/tb';
import { changeAllTitleFunction, converToStrDateTimeForAPI, openInNewTab } from '../Dashboard/functions';
import { style } from '@mui/system';
import { GrSend } from 'react-icons/gr';
import { Tooltip } from '@mui/material';
import { automateSftplogRecall, automateSftplogStatus, getAutomtedSFTPLogListData, getSFTPLogListData } from '../../../Redux/sftpClient/action';
import FacilityMultiSelectSelect from '../../CommonComponent/FacilityMultiSelectSelect';
import { setSeconds } from 'date-fns/esm';
import { endOfYear, setHours, setMinutes, startOfYear } from 'date-fns';
import TableHeadings from '../../common/TableHeadings';
import LogDetailsModal from './components/LogDetailsModal';
import { useRowLoaders } from '../../../hooks/dataTableRowLoader';
import ReasonModal from './components/ReasonModal';
import { FcCableRelease } from "react-icons/fc";
import { FaArrowsRotate } from 'react-icons/fa6';
import EmailLog from './components/EmailLog';
import {  BsClockHistory,  } from 'react-icons/bs';
import SchedulerLogModal from './components/SchedulerLogModal';
import Swal from 'sweetalert2';
import PartnerDropDown from '../../common/PartnerClientFacilityDropDown/PartnerDropDown';
import ClientDropDown from '../../common/PartnerClientFacilityDropDown/ClientDropDown';


const TextField = styled.input`
height: 32px;
width: 200px;
&:hover {
cursor: pointer;
}
`;
var input = {
    client: '',
    file: ''
};

const defaultColumns = {
    s_no: true,
    partner: true,
    client_name: true,
    facility_name: true,
    inbound_name: true,
    received_directory: true,
    received_file_name: true,
    user: true,
    file_type: true,
    status: true,
    received_date: true,
    modified_date: true,
    start_time: true,
    end_time: true,
    total_time: true,
    file_size: true,
    cron_server: true,
    log_record: true,
    offline: true,
    reset_by: true,
    file_size: true,
    action: true,
  
    
};

const AutomatedSFTPLog = () => {

    const [datetime, setDateTime] = useState([]);
    //////////////////////////////////////////////////////////////////


    const [loading, setLoading] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [loader, setLoader] = useState(null);
    const [totalRows, setTotalRows] = useState(100);
    const [limit, setLimit] = useState(100);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [data, setData] = useState({})
    const [colorRow, setColorRow] = React.useState({});

    const [filterText, setFilterText] = React.useState('');
    const [filterClient, setFilterClient] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const [sortColumn, setSortColumn] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [clientName, setClientName] = useState("")
    const [selectValue, setSelectValue] = useState([])
    const [showResonModal, setShowResonModal] = React.useState({modalStatus:false});
    const [clearSelection, setClearSelection] = React.useState(false);
    const [schedulerLogModalopen ,setSchedulerLogModalopen] =  useState({isOpen:false,pk:null})

     

    const [isSwal, setIsSwal] = useState({
        show: false,
        id: '',
        data: '',
    })
    const [isEdi, setIsEdi] = useState({
        show: false,
        id: '',
        data: '',
    })

    const [pageno, setPageNo] = useState(1);
    const [userlist, setUserlist] = useState();
    const [clientList, setClientList] = useState();

    const [settings, setSettings] = useState();
    const [toaster, setToaster] = useState(null);

    const [ToastMessage, setToastMessage] = useState({
        status: false,
        message: "",
        type: "",
    })
    const [filterState, setFilterState] = useState({
        staff: [],
        client: [],
        facility: [],
        client_group: [],
    })
    const [facilities, setFacilities] = useState([]);
    const [selectedFacility, setSelectedFacility] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalEmailLogShow, setModalEmailLogShow] = useState(false);
    const [selectedPk, setSelectedPk] = useState(null);
    const [loadingRows, setLoadingRows] = useState({}); 



    useEffect(() => {
        getUserlist(1)((response) => {
            setUserlist(response?.data?.results)
        });


        getAllClientDropdown()((response) => {

            setClientList(response?.data)
        })

    }, []);

    const [state, setState] = useState(defaultColumns);

    console.log(state, "FFFFF");

    const formik = useFormik({
        initialValues: {
            assignedqueue: "",
            staff: "",
        },
        // validationSchema,
        onSubmit: (values) => {
            __formSubmit(values)
        },
    });

    const __formSubmit = (values) => {
        getUserManualAssign(values?.staff, values?.assignedqueue)((response) => {
            setShowModal(false);
            if (response && response.status) {
                setToaster('success')
            }
            else {
                setToaster('error')
            }

        });
    };

    const resonFormik = useFormik({
        initialValues: { reason: "" },
        validationSchema: Yup.object({
            reason: Yup.string().required("Reason is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
             setLoadingStatus({type: showResonModal?.type?.toUpperCase()});
            console.log("Submitted reason:", values);
            // perform API call or other actions here
            const selectedIds = selectedRows?.map((row, index) => (row?.pk))
            const type = showResonModal?.type?.toUpperCase();
            let automateFunction;

            switch (type) {
                // case 'RECALL':
                //     automateFunction = automateSftplogRecall;
                //     break;
                case 'RELEASE':
                case 'HOLD':
                    automateFunction = automateSftplogStatus;
                    break;
                default:
                    automateFunction = null;
            }

            if (automateFunction) {
                automateFunction({ ids: selectedIds, reason: values?.reason, status: type })((response) => {
                    if (response?.status) {
                        fetchQueueListing({page:pageno, limit,sort_order:sortOrder,sort_key:sortColumn,...searchedData});
                        setToastMessage({
                            status: true,
                            message: 'Success',
                            type: "success",
                        });
                    } else {

                       
                        setToastMessage({
                            status: true,
                            message: 'Error',
                            type: 'danger',
                        })
                    }
                        setLoadingStatus({});
                        setSelectedRows([]);
                         setClearSelection(true);
                        setTimeout(() => setClearSelection(false), 0);


                });
            }


            resetForm();
            setShowResonModal(Prev=>({modalStatus:false}));
        },
    });


   const handleRecall =() => {
   const fileNames = selectedRows?.filter(item => !(item?.Received_file_name === "All Files")).map(i=>i?.received_file_name).join(', ');
    setShowResonModal({ modalStatus: false, type: 'recall' });
    setLoadingStatus({type:'RECALL'})

    Swal.fire({
        title: 'Are you sure?',
        text: `You want to process the file ${fileNames}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#6ba2b6', // green
        cancelButtonColor: '#6c757d',  // gray
    }).then((result) => {
        if (result.isConfirmed) {

            const selectedIds = selectedRows?.map((row, index) => (row?.pk))
            automateSftplogRecall({ ids: selectedIds })((response) => {
                if (response?.status) {
                    fetchQueueListing({page:pageno, limit,sort_order:sortOrder,sort_key:sortColumn,...searchedData});
                    setToastMessage({
                        status: true,
                        message: 'Success',
                        type: "success",
                    });
                } else {

                    setToastMessage({
                        status: true,
                        message: 'Error',
                        type: 'danger',
                    })
                }
                    setLoadingStatus({});
                    setSelectedRows([]);
                    
                    setClearSelection(true);
                    setTimeout(() => setClearSelection(false), 0);


            });
            setShowResonModal(Prev => ({ modalStatus: false }));
        }{
            setLoadingStatus({});

        }
        
    });

    }
    

    const checkUserPermission = (check) => {
        var permissions = JSON.parse(localStorage.getItem('permissions'))
        var data = permissions.find((element) => {
            return element == check;
        })
        // // console.log(data)
        if (data && data != undefined) {
            return true;
        }
        else {

            return false;
        }
    }

    

    const predefinedBottomRanges = [
        {
            label: 'Today',
            value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)],
            placement: 'left'
        },
        {
            label: 'Yesterday',
            value: [addDays(new Date().setHours(0, 0, 0, 0), -1), addDays(new Date().setHours(23, 59, 59, 59), -1)],
            placement: 'left'
        },
        {
            label: 'This week',
            value: [startOfWeek(new Date().setHours(0, 0, 0, 0)), new Date()],
            placement: 'left'
        },
        {
            label: 'Last 7 days',
            value: [subDays(new Date().setHours(0, 0, 0, 0), 6), new Date()],
            placement: 'left'
        },
        {
            label: 'Last 30 days',
            value: [subDays(new Date().setHours(0, 0, 0, 0), 29), new Date()],
            placement: 'left'
        },
        {
            label: 'This month',
            value: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date()],
            placement: 'left'
        },
        {
            label: 'Last month',
            value: [startOfMonth(addMonths(new Date().setHours(0, 0, 0, 0), -1)), endOfMonth(addMonths(new Date(), -1))],
            placement: 'left'
        },
        {
            label: 'This year',
            value: [new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0), new Date()],
            placement: 'left'
        },
        {
            label: 'Last year',
            value: [setSeconds(setMinutes(setHours(startOfYear(new Date(new Date().getFullYear() - 1, 0, 1)), 0), 0), 0), setSeconds(setMinutes(setHours(endOfYear(new Date(new Date().getFullYear(), 0, 0)), 23), 59), 59)],
            placement: 'left'
        },

        {
            label: 'Last week',
            closeOverlay: false,
            value: value => {
                const [start = new Date().setHours(0, 0, 0, 0)] = value || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
                ];
            },
            appearance: 'default'
        },
        {
            label: 'Next week',
            closeOverlay: false,
            value: value => {
                const [start = new Date()] = value || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
                ];
            },
            appearance: 'default'
        }
    ];
    const handleOnMultySelectChange = async (selected, name) => {

        let selectedIds = [];
        selected.map((option) => {
            selectedIds.push(option.value)
        })

        queueformik.setValues({ ...queueformik.values, [name]: selectedIds });


        setFilterState({
            ...filterState,
            [name]: selected
        })
        name === 'facility' && setSelectedFacility(selected)
        if (name === 'client' && selected?.length === 0) {
            setSelectedFacility([])
            queueformik.setFieldValue("facility", [])
            setFacilities([])
        }

    }
    const { setLoading: rowLoader, isRowLoading, clearLoading } = useRowLoaders();

const handleDownloadSftpLog = (row, log_record_url = 'log_record_url', isName = false) => {
    // Set this row to loading
    setLoadingRows(prev => ({ ...prev, [row?.pk]: true }));

    const fileURL = row?.[log_record_url];
    if (!fileURL) {
        console.error('No file URL found for this row');
        setLoadingRows(prev => ({ ...prev, [row.pk]: false }));
        return;
    }

    fetch(fileURL)
        .then(async response => {
            if (!response.ok) throw new Error('Network response was not ok');

            // Determine filename - always extract from URL path
            let filename = 'downloaded_file.log';
            
            // Extract filename from URL path (before query parameters)
            const urlWithoutParams = fileURL.split('?')[0];
            const pathParts = urlWithoutParams.split('/');
            const lastPart = pathParts[pathParts.length - 1];
            
            if (lastPart && lastPart.includes('.')) {
                filename = lastPart;
            }

            // If isName is true and you have a custom extraction function, use it
            if (isName) {
                const { fileName } = extractFileNameAndExtension(fileURL);
                if (fileName) {
                    filename = fileName;
                    // Ensure it has .log extension if missing
                    if (!filename.includes('.')) {
                        filename += '.log';
                    }
                }
            }

            const blob = await response.blob();
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.setAttribute('download', filename);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            
            // Clean up the object URL
            setTimeout(() => {
                window.URL.revokeObjectURL(downloadLink.href);
            }, 100);
        })
        .catch(error => {
            console.error('Error downloading file:', error);
        })
        .finally(() => {
            // Stop loading
            setLoadingRows(prev => ({ ...prev, [row.pk]: false }));
        });
};

// Simple function to extract filename from URL
const extractFileNameAndExtension = (url) => {
    try {
        // Remove query parameters first
        const urlWithoutParams = url.split('?')[0];
        // Get the last part of the path
        const pathParts = urlWithoutParams.split('/');
        const fullFileName = pathParts[pathParts.length - 1];
        
        if (fullFileName && fullFileName.includes('.')) {
            const lastDotIndex = fullFileName.lastIndexOf('.');
            const fileName = fullFileName.substring(0, lastDotIndex);
            const extension = fullFileName.substring(lastDotIndex);
            return { fileName: fullFileName, extension }; // Return full filename with extension
        }
        
        return { fileName: fullFileName || 'downloaded_file', extension: '.log' };
    } catch (error) {
        console.error('Error parsing URL:', error);
        return { fileName: 'downloaded_file', extension: '.log' };
    }
};
    


    const handleOpenSchedulerLog = (pk) => {        
      setSchedulerLogModalopen({isOpen:true,pk:pk})
    }
    

    const columns = useMemo(
        () => [
            {
                id: 'id',
                name: 'S NO',
                selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
                cell:(row,index) =>
                <div>
                   { pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1}
                   {row?.is_error_occured && <i class=" ms-2 blink blinking-text bi bi-exclamation-circle"></i>} 
                </div>,
                wrap: true,
                width: "70px",
                grow: 0,


                omit: !state?.s_no
            },
                {
                id: 'partner',
                name: 'Partner',
                selector: row => row?.partner,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.partner} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.partner}
                              
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "200px",
                grow: 0.3,

                omit: !state?.partner
            },

            {
                id: 'client',
                name: 'client',
                selector: row => row?.client_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }} onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.client_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.client_name}
                              
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "200px",
                grow: 0.3,

                omit: !state?.client_name
            },
            {
                id: 'facility',
                name: 'Facility',
                selector: row => row?.facility_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.facility_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.facility_name}
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "200px",
                grow: 0.3,

                omit: !state?.facility_name
            },
            {
                id: 'inbound_name',
                name: 'Inbound',
                selector: row => row?.inbound_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.inbound_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.inbound_name}
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "200px",
                grow: 0.3,

                omit: !state?.inbound_name
            },
            {
                id: 'received_directory',
                name: 'Received Directory',
                selector: row => row?.received_directory,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.received_directory} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.received_directory}
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "300px",
                grow: 0.3,

                omit: !state?.received_directory
            },
             {
                id: 'Received_file_name',
                name: 'Received File Name',
                selector: row => row?.received_file_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.received_file_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.received_file_name}
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "200px",
                grow: 0.3,

                omit: !state?.received_file_name
            },

            {
                id: 'user',
                name: 'user',
                selector: row => row?.user_name,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.user_name} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.user_name}
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "100px",
                grow: 0.3,

                omit: !state?.user
            },
            {
                id: 'file_type',
                name: 'File Type',
                selector: row => row?.file_type,
                cell: (row) => (
                    <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ width: "100%" }}
                    >
                        {/* <Tooltip disableInteractive title={row?.file_type} placement="top" arrow>
                            <span className="text-truncate me-2" style={{ maxWidth: '120px', overflow: 'hidden' }}>
                                {row?.file_type === true ?
                                    <Tooltip title="True" placement="top">
                                        <i className="bi bi-check text-success fs-5"></i>
                                    </Tooltip>
                                    : row?.file_type === false ?
                                        <Tooltip title="False" placement="top">
                                            <i className="bi bi-x text-danger fs-5"></i>
                                        </Tooltip> :
                                        <></>
                                }
                            </span>
                        </Tooltip> */}
                        {row?.file_type}

                    </div>
                ),
                // sortable: true,
                wrap: true,
                width: "110px",
                omit: !state?.file_type
            },
              {
                id: 'status',
                name: 'status',
                selector: row => row?.status,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.status} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.status}
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "100px",
                omit: !state?.status
            },
           
            {
                id: 'received_time',
                name: 'Received Date ',
                selector: row => row?.received_time,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                     {row?.received_time}
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "120px",
                grow: 0.3,

                omit: !state?.received_date
            },
            {
                id: 'modified_time',
                name: 'Modified Date ',
                selector: row => row?.modified_time,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                     {row?.modified_time}
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "120px",
                grow: 0.3,

                omit: !state?.modified_date
            },

            {
                id: 'start_time',
                name: 'Start Time',
                selector: row => row?.start_time,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                        {/* <Tooltip disableInteractive title={row?.user} placement='top' arrow> */}
                        < span className='text-truncate ' >
                            {/* {moment(row?.start_time).format('M/DD/YY, H:mm')} */}
                            {row?.start_time}
                        </span>
                        {/* </Tooltip> */}
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "120px",
                grow: 0.3,

                omit: !state?.start_time
            },
            {
                id: 'end_time',
                name: 'End Time',
                selector: row => row?.end_time,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                        {/* <Tooltip disableInteractive title={row?.user} placement='top' arrow> */}
                        < span className='text-truncate ' >
                            {/* {moment(row?.end_time).format('M/DD/YY, H:mm')} */}
                            {row?.end_time}
                        </span>
                        {/* </Tooltip> */}
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "120px",
                grow: 0.3,

                omit: !state?.end_time
            },

               {
                id: 'total_time',
                name: 'Total Time',
                selector: row => row?.total_time,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                        {/* <Tooltip disableInteractive title={row?.user} placement='top' arrow> */}
                        < span className='text-truncate ' >
                            {/* {moment(row?.end_time).format('M/DD/YY, H:mm')} */}
                            {row?.total_time}
                        </span>
                        {/* </Tooltip> */}
                    </div>,


                // sortable: true,
                wrap: true,
                width: "75px",
                grow: 0.3,

                omit: !state?.total_time

            },
            
             {
                id: 'file_size',
                name: 'File Size',
                selector: row => row?.file_size,
                sortable: true,
                wrap: true,
                width: "80px",
                omit: !state?.file_size
            },
            {
                id: 'cron_server',
                name: 'cron server',
                selector: row => row?.cron_server,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.cron_server} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.cron_server}
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "100px",

                omit: !state?.cron_server
            },
            {
                id: 'log_record',
                name: 'log record',
                selector: row => row?.log_record,
                cell: (row,ind) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        {row?.log_record != "" && (
                            loadingRows[row.pk] ?
                                <div className="spinner-border spinner-border-sm " role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                :
                                // <Tooltip disableInteractive title={row?.log_record} placement='top' arrow >

                                <i onClick={() => handleDownloadSftpLog(row, "log_record")} className="bi bi-download me-2 "></i>
                            // </Tooltip>
                        )}
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "100px",
                omit: !state?.log_record
            },
            {
                id: 'is_offline',
                name: 'Offline',
                selector: row => row?.is_offline,
                cell: (row) => (
                    <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ width: "100%" }}
                    >
                        {/* <Tooltip disableInteractive title={row?.is_offline} placement="top" arrow>
                            <span className="text-truncate me-2" style={{ maxWidth: '120px', overflow: 'hidden' }}>
                                {row?.is_offline === true ?
                                    <Tooltip title="True" placement="top">
                                        <i className="bi bi-check text-success fs-5"></i>
                                    </Tooltip>
                                    : row?.is_offline === false ?
                                        <Tooltip title="False" placement="top">
                                            <i className="bi bi-x text-danger fs-5"></i>
                                        </Tooltip> :
                                        <></>
                                }
                            </span>
                        </Tooltip> */}
                        {row?.is_offline}
                    </div>
                ),
                // sortable: true,
                wrap: true,
                width: "100px",
                grow: 0.3,
                omit: !state?.offline
            },
             {
                id: 'reset_by',
                name: 'Reset By',
                selector: row => row?.reset_by,
                cell: (row) =>
                    <div className='text-truncate ' style={{ width: "520px", overflow: 'hidden' }
                    } onClick={() => handleRowClick(row)}>
                        <Tooltip disableInteractive title={row?.reset_by} placement='top' arrow >
                            <span className='text-truncate ' >
                                {row?.reset_by}
                            </span>
                        </Tooltip>
                    </div>
                ,
                sortable: true,
                wrap: true,
                width: "100px",
                grow: 0.3,

                omit: !state?.reset_by
            },

            {
                id: 'edit',
                name: 'Action',
                cell: (row) => {

                    return (
                        <div
                            className="d-flex flex-row gap-2 justify-content-start align-items-center no-wrap"
                            onClick={() => handleRowClick(row)}
                        >
                            <React.Fragment>
                                <Tooltip disableInteractive title='Scheduler Log' placement='top' arrow>
                                    <Link className='d-flex align-items-center' style={{ fontSize: '1.5em', height: '32px' }} onClick={() => handleOpenSchedulerLog(row.pk)} >
                                        <BsClockHistory color={"#000000"} />
                                    </Link>
                                </Tooltip>
                            </React.Fragment>

                            {/* View Button */}
                            <Tooltip disableInteractive title="View Log" placement="top" arrow>
                                <button
                                    className="btn fs-7 fw-bold btn-sm btn-light-primary d-flex align-items-center justify-content-center"
                                    style={{ height: '32px', width: '32px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleViewLog(row);
                                    }}
                                >
                                    <i className="bi bi-eye fs-6"></i>
                                </button>
                            </Tooltip>

                            <Tooltip disableInteractive title="Email Log" placement="top" arrow>
                                <button
                                    className="btn fs-7 fw-bold btn-sm btn-light-primary d-flex align-items-center justify-content-center"
                                    style={{ height: '32px', width: '32px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleViewEmailLog(row);
                                    }}
                                >
                                    <i className="bi bi-envelope fs-6"></i>
                                </button>
                            </Tooltip>

                            {checkUserPermission('view_acknowledgement') &&
                                <Tooltip disableInteractive title="View ACK" placement="top" arrow>
                                    <button
                                        className="btn fs-7 fw-bold btn-sm btn-light-primary d-flex align-items-center justify-content-center"
                                        style={{ height: '32px', width: '32px' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleViewAck(row);
                                        }}
                                    >
                                        <i className="bi bi-file-earmark-check fs-6"></i>
                                    </button>
                                </Tooltip>
                            }
                        </div>
                    );
                },
                ignoreRowClick: false,
                width: '140px', // Adjusted to fit all buttons
                allowOverflow: true,
                 omit: !state?.action
            }


        ],
        [pageno, loading, state ,loadingRows],
    );



    const handleSort = (column, sortDirection) => {
        setSortColumn(column.id);
        setSortOrder(sortDirection);
        fetchQueueListing({page:pageno, limit, sort_key:column.id, sort_order:sortDirection,...searchedData});
    };

    const fetchQueueListing = async (props) => {
        const {page,deposit_date_range} = props;
        setLoading(true);
        getAutomtedSFTPLogListData({
            ...props,
            created_date: converToStrDateTimeForAPI(deposit_date_range),

        })((response) => {
            if (response?.status) {
                setData(response.data);
                setTotalRows(response.data.count);
                setPageNo(page);
            }
            setLoading(false);
        });
    };

    const handlePageChange = page => {
        setPageNo(page)
        fetchQueueListing({page, limit,sort_order:sortOrder,sort_key:sortColumn,...searchedData});
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchQueueListing({page, limit:newPerPage,sort_order:sortOrder,sort_key:sortColumn,...searchedData})
        setLimit(newPerPage)
        handleResetDataTable()

    };

    const [searchedData, setSearchedData] = useState({
        search: "",
        client: "",
        deposit_date_range: "",
        created_date: "",
        status: "",
        facility: "",
    })
    const [reRenderDataTable, setRerenderDataTable] = useState(false)

    const handleResetDataTable = () => {
        setRerenderDataTable(true)
        setTimeout(() => {
            setRerenderDataTable(false)
        }, 200);
    }
    const queueformik = useFormik({
        enableReinitialize: true,
        initialValues: {
            partner: [],
            client: [],
            facility: [],
            deposit_date_range: [],
            created_date: "",
            status: [],
            file_name: '',
            fileType: null,
            directory:'',
            is_error_occured:false,
        },

        onSubmit: (values) => {
            
            setSortColumn("")
            setSortOrder("")

            fetchQueueListing({page:1, limit,sort_order:sortOrder,sort_key:sortColumn,...values})
            setSearchedData({
                search: values?.search ? values?.search : "",
                client: values?.client ? values?.client : "",
                deposit_date_range: values?.deposit_date_range ? values?.deposit_date_range : "",
                created_date: values?.created_date ? values?.created_date : "",
                status: values?.status ? values?.status : "",
                facility: values?.facility ? values?.facility : "",
                is_error_occured:values?.is_error_occured ,
                file_name:values?.file_name,
                fileType:values?.fileType,
                directory:values?.directory,
                is_from_alerts:false
            })
            handleResetDataTable()
            setSelectedRows([])
        },

    });

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('is_from_alerts') === 'true') {
           
            const status = [
                "PENDING",
                "IN_QUEUE",
                "FAILED",
                "IN_PROGRESS"
            ]
            queueformik.setFieldValue('status',status );
            setSearchedData(prev => ({
                ...prev,
                status:status,
                is_from_alerts:true
            }));
            fetchQueueListing({page:1, limit,sort_order:sortOrder,sort_key:sortColumn,...queueformik.values,status:status,is_from_alerts:true});
        }
    }, []);


    const handleRowSelected = React.useCallback(state => {
        // var ids = [];

        // console.log(state);
        
        // state.selectedRows.map((row, index) => {
        //     ids.push(row.id);
        // })
        setSelectedRows(state?.selectedRows);
    }, []);

    const handleOnDateTimeChange = ({ name, value }) => {
        let created_date = ""
        if (value !== null) {
            const datefrom = moment(value['0']).format('MM/DD/YYYY')
            const dateto = moment(value['1']).format('MM/DD/YYYY')

            created_date = datefrom + " - " + dateto
        }
        setDateTime(created_date)

        queueformik.setValues({ ...queueformik.values, created_date, deposit_date_range: value ?? "" })


    }

    const handleOnSelectClientChange = async (e, name) => {
        let selectedId = []
        let selectedOptons = []

        e.map((option) => {
            selectedId.push(option.value)
            selectedOptons.push({ option })
        })
        if (selectedOptons.length === 0) {
            setSelectedFacility([])
            setFacilities([])
        }
        queueformik.setValues({ ...queueformik.values, [name]: selectedId })
        setSelectValue(selectedOptons)
        setClientName(selectedId)
    }
    var i = 0;

    const conditionalRowStyles = [

        {
            when: row => { i = i + 1; return i % 2 == 0 || colorRow.pk == row.pk ? true : false },
            style: (row, index) => ({
                backgroundColor: colorRow?.pk == row.pk ? '#dbf4f5' : '#f2f2f2',
            }),
        },

    ];

    const handleRowClick = (row) => {
        setColorRow(row);
    };
    const handleRowCheckClick = (row) => {
        data?.results?.map((item, index) => {
            if (row?.pk == item.pk) {
                setColorRow(row)
            }
        })
    };

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props} >

                {
                    queueformik.values[state]?.length > 1 ? (
                        <TbGridDots style={{ fontSize: "1.5em" }
                        } />
                    ) : (
                        <HiChevronDown style={{ fontSize: "1.5em" }} />
                    )}



            </components.DropdownIndicator>
        );
    };

    const [isFocusedClient, setIsFocusedClient] = useState(false);
    const [isFocusedStatus, setIsFocusedStatus] = useState(false);
    const [isFocusUser, setIsFocusUser] = useState(false);
    const [isFocusResetUser, setIsFocusResetUser] = useState(false);

    const statusList = [
        { label: 'PENDING', value: 'PENDING' },
        { label: 'HOLD', value: 'HOLD' },
        { label: 'INITIAL QUEUE', value: 'INITIAL_QUEUE' },
        { label: 'IN QUEUE', value: 'IN_QUEUE' },
        { label: 'IN PROGRESS', value: 'IN_PROGRESS' },
        { label: 'COMPLETED', value: 'COMPLETED' },
        { label: 'FAILED', value: 'FAILED' },
        { label: 'INVALID REQUEST', value: 'INVALID_REQUEST' },
        { label: 'SERVER FAILED', value: 'SERVER_FAILED' },
        { label: 'RESET', value: 'RESET' },
    ];
    const fileTypeOptions = [
        { label: 'EOB', value: 'EOB' },
        { label: '837/SELF-PAY', value: 'CLAIM' },

    ];
    const resetData = () => {
        queueformik.setValues(queueformik?.initialValues)
        setSelectValue([])
        setSelectedFacility([])
        setFilterState({
            staff: [],
            client: [],
            facility: [],
            client_group: [],
        })
        setSearchedData({})
        setSortColumn("")
        setSortOrder("")
        fetchQueueListing({page:1, limit,sort_order:sortOrder,sort_key:sortColumn,...queueformik?.initialValues})
        handleResetDataTable()
    }
    const formatOptionLabel = ({ value, label, is_logged_in }) => (
        <div className='d-flex flex-row justify-content-between align-items-center'>
            <div>{label}</div>
            {is_logged_in ?
                <div className='ms-2 dot' />
                :
                <div></div>
            }
        </div>
    );

    const handleUserSelectChange = (selected, field) => {
        const values = selected?.map(opt => opt.value) || [];
        queueformik.setFieldValue(field, values);
    };

    const handleViewLog = (row) => {
        setSelectedPk(row?.pk)
        setModalShow(true);
    };
    // Open the Acknowledgement page in a new tab, filtered to this scheduler run
    const handleViewAck = (row) => {
        openInNewTab("Acknowledgement", GET_ACKNOWLEDGMENT_LIST + "?scheduler_id=" + row?.pk)
    };
    const handleViewEmailLog = (row) => {
        setSelectedPk(row?.pk)
        setModalEmailLogShow(true);
    };
   const viewEditButtonAccess =  checkUserPermission('edit_automate_sftp_logs') ? false :  true
    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} />

            <main id="main" className="main" >

                <div className="pagetitle tab-fixed-header " >
                    <h1 id='page-title' >Automate SFTP Logs </h1>
                </div>

                < ToastContainer className="p-3" position={"top-end"} >
                    <Toast bg={ToastMessage?.type} onClose={() => setToastMessage(
                        {
                            status: false,
                            message: "",
                            type: "",
                        }

                    )}
                        show={ToastMessage?.status} animation={true} delay={2000} autohide >
                        <Toast.Body><span className='text-white' > {ToastMessage?.message} </span></Toast.Body >
                    </Toast>

                </ToastContainer>

                < section className="section mt-5" >
                    <div className="row align-items-top py-2 gap-2 gap-md-5" >
                        <div className="col-lg-12" >
                            <div className="card mb-5 mb-xl-8" >
                                <Form onSubmit={queueformik.handleSubmit} onReset={resetData}>
                                    <div className='' >
                                        <div className="d-flex flex-row justify-content-start gap-2 align-items-center px-4 py-4 flex-wrap py-3" >
                                            <div>
                                                <PartnerDropDown lockboxformik={queueformik} name="partner" />
                                            </div>
                                          <div>
                                            <ClientDropDown lockboxformik={queueformik} name="client" />
                                          </div>
                                            < div style={{ minWidth: "250px", maxWidth: "250px" }} className="d-flex p-2  align-items-center" >
                                                <FacilityMultiSelectSelect setFacilities={setFacilities} options={facilities} clients={queueformik?.values?.client} facility={selectedFacility} setSelectedFacility={setSelectedFacility} handleChange={handleOnMultySelectChange} formik={queueformik} />
                                            </div>
                                            < div style={{ minWidth: "250px", maxWidth: "250px" }} className="d-flex p-2  align-items-center" >
                                                <TextField
                                                    id="search"
                                                    className="form-control form-control-solid  b-r-10"
                                                    name='directory'
                                                    type="search"
                                                    style={{ width: "100%" }}
                                                    placeholder="Directory "
                                                    aria-label="Search Input"
                                                    value={queueformik.values?.directory}
                                                    // value={input.file}
                                                    onChange={queueformik.handleChange}
                                                />
                                            </div>
                                            < div style={{ minWidth: "250px", maxWidth: "250px" }} className="d-flex p-2  align-items-center" >
                                                <TextField
                                                    id="search"
                                                    className="form-control form-control-solid  b-r-10"
                                                    name='file_name'
                                                    type="search"
                                                    style={{ width: "100%" }}
                                                    placeholder="File Name "
                                                    aria-label="Search Input"
                                                    value={queueformik.values?.file_name}
                                                    // value={input.file}
                                                    onChange={queueformik.handleChange}
                                                />
                                            </div>


                                            < Tooltip disableInteractive title="Received Date" placement='top' arrow >

                                                <div className='' >
                                                    <Stack direction="column" spacing={8} alignItems="flex-start" >

                                                        <DateRangePicker
                                                            ranges={predefinedBottomRanges}
                                                            // style={{ backgroundColor: "#000" }}
                                                            cleanable
                                                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                            appearance="default"
                                                            format={"MM/dd/yyyy HH:mm"}
                                                            placement='auto'
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            className="form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker"
                                                            name="deposit_date_range"
                                                            onChange={(e) => { handleOnDateTimeChange({ name: 'deposit_date_range', value: e }) }}
                                                            value={queueformik?.values?.deposit_date_range} />

                                                    </Stack>
                                                </div>
                                            </Tooltip>
                                            < div className='jobmonitor-select' >
                                                <Select
                                                    isMulti
                                                    options={statusList}
                                                    components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="status" /> }}
                                                    className="select-search-client "
                                                    classNamePrefix="select"
                                                    placeholder="Status"
                                                    menuPlacement="auto"
                                                    maxMenuHeight={300}
                                                    isClearable
                                                    name="status"
                                                    onChange={(e) => {
                                                        queueformik.setValues({
                                                            ...queueformik.values,
                                                            status: e?.map(i => i.value)
                                                        })
                                                    }}
                                                    value={statusList.filter(i => queueformik?.values?.status.includes(i.value))}
                                                    onFocus={() => setIsFocusedStatus(true)}
                                                    onBlur={() => setIsFocusedStatus(false)}
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={false}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),

                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusedStatus ? "auto" : "30px",
                                                        }),

                                                    }}
                                                />
                                            </div>
                                            < div className='jobmonitor-select' >
                                                <Select
                                                    options={fileTypeOptions}
                                                    components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="status" /> }}
                                                    className="select-search-client"
                                                    classNamePrefix="select"
                                                    placeholder="File Type"
                                                    menuPlacement="auto"
                                                    maxMenuHeight={300}
                                                    isClearable
                                                    name="fileType"
                                                    onChange={(e) => {
                                                        queueformik.setFieldValue("fileType", e?.value || "");
                                                    }}
                                                    value={fileTypeOptions?.find(i => i.value === queueformik?.values?.fileType)||null}
                                                    onFocus={() => setIsFocusedStatus(true)}
                                                    onBlur={() => setIsFocusedStatus(false)}
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={true}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),
                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusedStatus ? "auto" : "30px",
                                                        }),
                                                    }}
                                                />
                                            </div>
                                            < div className='jobmonitor-select' >
                                                <Select
                                                    isMulti
                                                    options={userlist}
                                                    formatOptionLabel={formatOptionLabel}
                                                    className="select-search"
                                                    classNamePrefix="select"
                                                    placeholder="User"
                                                    name="user"
                                                    value={userlist?.filter(opt => queueformik.values?.user?.includes(opt?.value))}
                                                    onFocus={() => setIsFocusUser(true)}
                                                    onBlur={() => setIsFocusUser(false)}
                                                    isClearable  // onChange={queueformik.handleChange}
                                                    onChange={(e) => handleUserSelectChange(e, 'user')}
                                                    defaultValue={queueformik?.values?.user}

                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={false}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),
                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusUser ? "auto" : "30px",
                                                        }),
                                                    }}
                                                />

                                            </div>
                                            < div className='jobmonitor-select' >
                                                <Select
                                                    isMulti
                                                    options={userlist}
                                                    formatOptionLabel={formatOptionLabel}
                                                    className="select-search"
                                                    classNamePrefix="select"
                                                    placeholder="Reset User"
                                                    name="reset_user"
                                                    value={userlist?.filter(opt => queueformik.values?.reset_user?.includes(opt?.value))}

                                                    isClearable  // onChange={queueformik.handleChange}
                                                    onChange={(e) => handleUserSelectChange(e, 'reset_user')}
                                                    defaultValue={queueformik?.values?.reset_user}
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={false}
                                                    onFocus={() => setIsFocusResetUser(true)}
                                                    onBlur={() => setIsFocusResetUser(false)}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),
                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusResetUser ? "auto" : "30px",
                                                        }),
                                                    }}
                                                />

                                            </div>
                                            <Tooltip disableInteractive title="Error Log Records" placement='top' arrow >
                                                <div className="form-check form-switch " >
                                                    <input className="form-check-input" onChange={(e) =>
                                                        queueformik.setFieldValue("is_error_occured", e.target.checked)
                                                    } type="checkbox" checked={queueformik.values?.is_error_occured} role="switch" id="flexSwitchCheckDefault" />
                                                </div>
                                            </Tooltip>


                                            < div className='' style={{ width: '' }}>
                                                <div className='d-flex justify-content-start gap-2' >
                                                    <Tooltip disableInteractive title="Search" placement='top' arrow >
                                                        <Button className="btn btn-light btn-active-primary  " type="submit" >
                                                            <span className="svg-icon svg-icon-3" >
                                                                <BiSearch />
                                                            </span>

                                                        </Button>
                                                    </Tooltip>
                                                    < Tooltip disableInteractive title="Reset" placement='top' arrow >
                                                        <Button className="btn btn-light btn-active-primary " type='reset' >
                                                            <span className="svg-icon svg-icon-3" >
                                                                <BiReset />
                                                            </span>

                                                        </Button>
                                                    </Tooltip>

                                                    <TableHeadings
                                                        columnState={state}
                                                        setColumnState={setState}
                                                    />
                                                    {selectedRows?.length > 0 &&


                                                        <>

                                                            {/* Hold Button */}
                                                            <div>
                                                                <Tooltip disableInteractive title="Hold" placement='top' arrow>
                                                                    <Button
                                                                        className='btn btn-light btn-active-primary jobMonitor-Buttons'
                                                                        disabled={
                                                                            selectedRows?.some(el => ["hold",'completed' ].includes(el?.status?.toLowerCase())) ||
                                                                            (loadingStatus?.type === "HOLD" ) || viewEditButtonAccess
                                                                        }
                                                                        onClick={() => setShowResonModal({ modalStatus: true, type: 'hold' })}
                                                                    >
                                                                        {loadingStatus?.type === "HOLD" 
                                                                            ? <Spinner animation="border" size="sm" />
                                                                            : <TbHandGrab className='jobMonitor-svg' />
                                                                        }
                                                                    </Button>
                                                                </Tooltip>
                                                            </div>

                                                            {/* Release Button */}
                                                            <div>
                                                                <Tooltip disableInteractive title="Release" placement='top' arrow>
                                                                    <Button
                                                                        className='btn btn-light btn-active-primary jobMonitor-Release-Buttons'
                                                                        style={{ width: '70px' }}
                                                                        disabled={
                                                                            selectedRows?.some(el => !["hold"].includes(el?.status?.toLowerCase())) ||
                                                                            (loadingStatus?.type === "RELEASE" ) || viewEditButtonAccess
                                                                        }
                                                                        onClick={() => setShowResonModal({ modalStatus: true, type: 'release' })}
                                                                    >
                                                                        {loadingStatus?.type === "RELEASE" 
                                                                            ? <Spinner animation="border" size="sm" />
                                                                            : "Release"
                                                                        }
                                                                    </Button>
                                                                </Tooltip>
                                                            </div>

                                                            {/* Recall Button */}
                                                            <div>
                                                                <Tooltip disableInteractive title="Recall" placement='top' arrow>
                                                                    <Button
                                                                        className='btn btn-light btn-active-primary jobMonitor-Recall-Buttons'
                                                                        disabled={
                                                                            selectedRows?.some(el => ["hold"].includes(el?.status?.toLowerCase())) ||
                                                                            (loadingStatus?.type === "RECALL" ) || viewEditButtonAccess
                                                                        }
                                                                        onClick={() => {  handleRecall()} }
                                                                    >
                                                                        {loadingStatus?.type === "RECALL" 
                                                                            ? <Spinner animation="border" size="sm" />
                                                                            : <FaArrowsRotate />
                                                                        }
                                                                    </Button>
                                                                </Tooltip>
                                                            </div>
                                                        </>


                                                    }

                                                </div>
                                               

                                            </div>

                                        </div>

                                    </div>
                                </Form>
                                < div className="card-body" style={{ padding: "0px 2.25rem" }}>
                                    <div className="table-responsive" >
                                        <div className="dashboardtable" >
                                            {!reRenderDataTable &&
                                                <DataTable
                                                    className="custom-datatable"
                                                    fixedHeader={true}

                                                    data={data?.results?.data}
                                                    columns={columns}
                                                    progressPending={loading}
                                                    pagination
                                                    paginationServer
                                                    onSelectedRowsChange={handleRowSelected}
                                                    paginationTotalRows={totalRows}
                                                    paginationPerPage={limit}
                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    conditionalRowStyles={conditionalRowStyles}
                                                    onRowClicked={handleRowCheckClick}
                                                    theme="solarized"
                                                    pointerOnHover
                                                    customStyles={queueDatatableCustomStyles}
                                                    responsive={true}
                                                    sortServer
                                                    onSort={handleSort}
                                                    selectableRows
                                                    // onSelectedRowsChange={handleRowSelected}
                                                    selectableRowsHighlight
                                                    selectableRowsSingle={false}
                                                    clearSelectedRows={clearSelection}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <LogDetailsModal
                    show={modalShow}
                    onClose={() => setModalShow(false)}
                    pk={selectedPk}
                />
                <EmailLog
                    show={modalEmailLogShow}
                    onClose={() => setModalEmailLogShow(false)}
                    pk={selectedPk}
                     customStyles={queueDatatableCustomStyles}
                     handleDownloadSftpLog={handleDownloadSftpLog}
                />
                <ReasonModal
                    showResonModal={showResonModal}
                    setShowResonModal={setShowResonModal}
                    resonFormik={resonFormik}
                    selectedRows={selectedRows}
                />
                <SchedulerLogModal
                    show={schedulerLogModalopen?.isOpen}
                    onClose={()=>setSchedulerLogModalopen({isOpen:false,pk:null})}
                    pk={schedulerLogModalopen?.pk}
                    
                />
            </main>

        </React.Fragment>
    )
}

export default AutomatedSFTPLog;